export function RenderMarketsQueryFilter(markets: any[], query: any): any[] {
    let marketsTrimmed = markets;

    if (query["two"] === true) {
        marketsTrimmed = markets.slice(0, 2);
    } else if (query["three"] === true) {
        marketsTrimmed = markets.slice(0, 3);
    } else if (query["four"] === true) {
        marketsTrimmed = markets.slice(0, 4);
    }
    return marketsTrimmed;
}
